// extracted by mini-css-extract-plugin
export var boxItems = "_89-1";
export var boxItemsLg = "_89-2";
export var button = "_89-7";
export var buttonHoverless = "_89-9";
export var buttonLg = "_89-8";
export var filterGroupBox = "_89-0";
export var icon = "_89-3";
export var iconSecondary = "_89-6";
export var iconWrapper = "_89-4";
export var iconWrapperLg = "_89-5";
export var truncatedLabel = "_89-a";